__turbopack_context__.v({
  "horizontalWrapper": "Profile-module-sass-module__eLfn2W__horizontalWrapper",
  "imageLoading": "Profile-module-sass-module__eLfn2W__imageLoading",
  "main": "Profile-module-sass-module__eLfn2W__main",
  "userImage": "Profile-module-sass-module__eLfn2W__userImage",
  "verticalWrapper": "Profile-module-sass-module__eLfn2W__verticalWrapper",
});
